import { Sparkles } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { forwardRef, useEffect, useState } from "react";
import { supabase } from "@/lib/supabase/client";
import { Dialog, DialogContent, DialogTitle } from "@/components/DialogCard";

const DailyDareSection = forwardRef<HTMLElement>(function DailyDareSection(_, ref) {
    const [dareContent, setDareContent] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(localStorage.getItem("ShowDailyDarePopup") === "true");

    useEffect(() => {
        const getTodaysDare = async () => {
            const { data, error } = await supabase.from("todays_dare").select("content");
            if (error) {
                console.error(error);
                return;
            }
            const content = data[0].content;
            setDareContent(content);
            if (content !== localStorage.getItem("DailyDareContent")) {
                localStorage.setItem("DailyDareContent", content);
                setDialogOpen(true);
                localStorage.setItem("ShowDailyDarePopup", "true");
            }
        };
        getTodaysDare();
    }, []);

    return (
        <section className="py-16 bg-muted/30" ref={ref}>
            <div className="container mx-auto px-6">
                <div className="max-w-2xl mx-auto">
                    <Card className="bg-gradient-card border-primary/20 shadow-lg">
                        <CardContent className="p-8 text-center">
                            <div className="flex items-center justify-center mb-4">
                                <Sparkles className="w-8 h-8 text-primary mr-3" />
                                <h2 className="text-2xl font-bold text-foreground">Dagens Dare</h2>
                            </div>
                            <p className="text-lg text-muted-foreground mb-6 leading-relaxed">
                                {dareContent ?? "Laddar..."}
                            </p>
                            <div className="text-sm text-muted-foreground/70">
                                💭 Reflektion för {new Date().toLocaleDateString('sv-SE', {
                                    weekday: 'long',
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric'
                                })}
                            </div>
                        </CardContent>
                    </Card>
                </div>
            </div>

            <Dialog open={dialogOpen} onOpenChange={(open) => {
                if (open) return;
                setDialogOpen(false);
                localStorage.setItem("ShowDailyDarePopup", "false");
            }}>
                <DialogContent>
                    <CardContent className="p-8 text-center">
                        <DialogTitle>
                            <div className="flex items-center justify-center mb-4">
                                <Sparkles className="w-8 h-8 text-primary mr-3" />
                                <h2 className="text-2xl font-bold text-foreground">Dagens Dare</h2>
                            </div>
                        </DialogTitle>
                        <p className="text-lg text-muted-foreground mb-6 leading-relaxed">
                            {dareContent ?? "Laddar..."}
                        </p>
                        <div className="text-sm text-muted-foreground/70">
                            💭 Reflektion för {new Date().toLocaleDateString('sv-SE', {
                                weekday: 'long',
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric'
                            })}
                        </div>
                    </CardContent>
                </DialogContent>
            </Dialog>
        </section >
    );
});
export default DailyDareSection;
